module.exports = __webpack_public_path__ + "2c94bb91d6d23f5fceee5d9ef0328e63.png";


//////////////////
// WEBPACK FOOTER
// ./components/app/common/app-menu/logo-white.png
// module id = 571
// module chunks = 0